import React from "react";
import { useSelector } from "react-redux";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const Member = () => {
  const partners = useSelector((state) => state.partners.partners);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="container mx-auto ">
      <div className="card bg-base-100 shadow-xl">
        <div className="card-body">
          <Slider {...settings} className="partner-slider">
            {partners.map((partner) => (
              <div key={partner.id} className="px-2">
                <div className="flex shadow-md rounded-lg p-2 gap-4 my-2 bg-base-100 hover:bg-gray-200">
                  <div className="w-full flex justify-center">
                    {partner?.userAvatar ? (
                      <img
                        src={partner.userAvatar}
                        alt={partner.userFullName}
                        className="rounded-md object-contain w-40 h-40"
                        style={{ aspectRatio: 1 / 1 }}
                        loading="lazy"
                      />
                    ) : (
                      <img
                        src={`https://ui-avatars.com/api/?name=${partner.companyName}&size=200&background=random&color=fff&bold=true`}
                        alt="Profile"
                        className="rounded-md object-contain w-40 h-40"
                        loading="eager"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = `https://ui-avatars.com/api/?name=${partner.companyName}&size=200&background=random&color=fff&bold=true`;
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      <style jsx>{`
        .vertical-partner-slider .slick-prev,
        .vertical-partner-slider .slick-next {
          left: 50%;
          transform: translateX(-50%);
        }

        .vertical-partner-slider .slick-prev {
          top: -20px;
        }

        .vertical-partner-slider .slick-next {
          top: auto;
          bottom: -20px;
        }

        .vertical-partner-slider .slick-prev:before,
        .vertical-partner-slider .slick-next:before {
          color: #666;
        }

        .vertical-partner-slider .slick-dots {
          right: -20px;
          left: auto;
          top: 50%;
          transform: translateY(-50%);
          width: auto;
          height: auto;
          display: flex !important;
          flex-direction: column;
        }

        .vertical-partner-slider .slick-dots li {
          margin: 5px 0;
        }

        .vertical-partner-slider .slick-track {
          display: flex;
          flex-direction: column;
        }
      `}</style>
    </div>
  );
};

export default Member;
